
import React, { Fragment, useCallback } from 'react'
import { Col, Form, Row } from 'react-bootstrap'

import useTranslation from '../../Hooks/UseTranslation'
import { useProgrammation } from '../../Hooks/UseProgrammation'

import TaskName from './FormFields/TaskName'
import TaskGroup from './FormFields/TaskGroup'
import TaskParent from './FormFields/TaskParent'
import TaskWorks from './FormFields/TaskWorks'
import TaskDescription from './FormFields/TaskDescription'
import TaskType from './FormFields/TaskType'
import TaskDate from './FormFields/TaskDate'
import TaskActualDates from './FormFields/TaskDates/TaskActualDates'
import TaskScheduledDates from './FormFields/TaskDates/TaskScheduledDates'
import TaskProgress from './FormFields/TaskProgress'
import TaskStatus from './FormFields/TaskStatus'
import TaskColorCode from './FormFields/TaskColorCode'

import ContentBlock from './components/ContentBlock'
import TaskBaseDates from './FormFields/TaskDates/TaskBaseDates'

interface Props {
  taskList: any[]
}

const TaskGeneralInfo = ({ taskList }: Props) => {

  const { t } = useTranslation()

  const { itemOpened: task } = useProgrammation()

  const type = task.type || ''

  const collapseKey = 'task-general-info-collapse'

  const isCollapsed = useCallback(() => {
    const isCollapsed = localStorage.getItem(collapseKey)

    if (isCollapsed === 'true') {
      return true
    }

    return false
  }, [])

  return (
    <ContentBlock
      title={t('PROGRAMMATION_MANAGER:TaskGeneralTitle')}
      collapsable
      collapseKey={collapseKey}
      isCollapsed={isCollapsed()}
    >
      <Form>
        <TaskName />
        <Row>
          <Col sm={4}>
            <TaskType type={type} />
          </Col>
          {type && (
            <Col sm={8}>
              {type !== 'trabajo' && (
                <TaskGroup task={task} taskList={taskList} />
              )}
              {type === 'trabajo' && (
                <TaskParent task={task} taskList={taskList} />
              )}
            </Col>
          )}
        </Row>
        {(type === 'hito' || type === 'reunion') && (
          <Row>
            <Col sm={4}>
              <TaskDate
                label="PROGRAMMATION_MANAGER:DateLabel"
                fieldName="startsAt"
              />
            </Col>
          </Row>
        )}
        {(type !== 'hito' && type !== 'reunion') && (
          <>
            <TaskBaseDates />
            <TaskScheduledDates />
          </>
        )}
        <TaskDescription />
        {type !== 'hito' && type !== 'reunion' && (
          <Fragment>
            <Row>
              <Col sm={4} style={{ overflow: 'visible'}}>
                <TaskDate
                  label='PROGRAMMATION_MANAGER:ReleasesAtLabel'
                  fieldName="releasesAt"
                />
              </Col>
              <Col sm={4}>
                <TaskColorCode />
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <TaskStatus />
              </Col>
              <Col sm={8}>
                <TaskProgress />
              </Col>
            </Row>
          </Fragment>
        )}
        {task.startedAt && (
          <TaskActualDates />
        )}
      </Form>
      {task.type === 'partida' && (
        <TaskWorks items={task.subTasks || []} />
      )}
    </ContentBlock>
  )
}

export default TaskGeneralInfo
